import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Toast, ToastCollection } from '@els/els-react--toast';
import { AppConstant } from 'constants/app.constant';
import { toastActions } from 'redux/ducks/toast';
var ELSToast = function () {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) { return state[AppConstant.reduxResources.TOAST_STATE]; }), message = _a.message, color = _a.color;
    var handleClose = useCallback(function () {
        dispatch(toastActions.hideToast());
    }, [dispatch]);
    if (!message)
        return null;
    return (<ToastCollection horizontalPosition="right" verticalPosition="top">
      <Toast color={color} onClose={handleClose} autoHide visibleTime={5000}>
        <span>{message}</span>
      </Toast>
    </ToastCollection>);
};
export default ELSToast;
